import { render, staticRenderFns } from "./registrationByHour.vue?vue&type=template&id=4bfa1d3c&scoped=true"
import script from "./registrationByHour.vue?vue&type=script&lang=js"
export * from "./registrationByHour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfa1d3c",
  null
  
)

export default component.exports